import { IDigitalWalletPaymentRequest, WalletType } from "models/digitalWallet/IDigitalWallet";
import React from "react";
import { AuthorizeMerchantApple } from "services/Api/digitalWallet/DigitalWalletApi";
import { ApplePayButtonProps } from "./ApplePayButtonProps";

const ApplePayButton: React.FC<ApplePayButtonProps> = ({ amount, disabled, onSubmit, validateForm }) => {
  const startApplePay = async () => {
    //if (validateForm()) {
    //  return;
    //}

    if (!window.ApplePaySession) {
      alert("Apple Pay não é suportado neste navegador.");
      return;
    }

    if (!ApplePaySession.canMakePayments()) {
      alert("Apple Pay não está disponível neste dispositivo.");
      return;
    }

    const session = new ApplePaySession(6, {
      countryCode: "BR",
      currencyCode: "BRL",
      merchantCapabilities: ["supports3DS"],
      supportedNetworks: ["visa", "masterCard", "amex"],
      total: { label: "MEEP SOLUCOES SA", amount: amount.toString() },//amount.toString() },
    });

    session.onvalidatemerchant = async (event) => {
      try {

        console.log("event", event.validationURL);
        const merchantSession = await AuthorizeMerchantApple(event.validationURL);

        //const merchantSession = mockValidate as any;


        console.log("merchantSession", merchantSession);

        session.completeMerchantValidation(merchantSession);
      } catch (err) {
        console.error("Erro na validação do merchant:", err);
        session.abort();
      }
    };

    session.onpaymentauthorized = async (event) => {
      console.log("event", event);
      const paymentData = event.payment.token.paymentData;
      // envie o token para seu backend (Cielo)

      console.log("paymentData", paymentData);
      const payload: IDigitalWalletPaymentRequest = {
        type: WalletType.ApplePay,
        walletKey: paymentData.data,
        ephemeralPublicKey: paymentData.header.ephemeralPublicKey,
        signature: paymentData.signature,
      };

      try {
        console.log("payload", payload);
        const response = await onSubmit(payload);
        console.log("response", response);
        session.completePayment(ApplePaySession.STATUS_SUCCESS);
      } catch (error) {
        console.error("Erro ao enviar o payload:", error);
        session.completePayment(ApplePaySession.STATUS_FAILURE);
      }
    };

    session.begin();
  };

  return (
    <button
      onClick={startApplePay}
      disabled={disabled}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        WebkitAppearance: "-apple-pay-button",
        appearance: "-apple-pay-button",
        "--apple-pay-button-type": "plain",
        "--apple-pay-button-style": "black",

        height: "44px",
        borderRadius: "8px",
      } as unknown as React.CSSProperties}
    >
      {/*Pagar com Pay*/}
    </button>
  );
};

export default ApplePayButton;


//const mockValidate ={
//  "epochTimestamp": 1761796338679,
//  "expiresAt": 1761799938679,
//  "merchantSessionIdentifier": "SSH85F11DB68A064F1AB36154A32AE4C5C8_BB8E62003687F8FCC159B2B83AAFC02DB625F1F1E3997CCC2FE2CFD11F636558",
//  "nonce": "ba0d18ff",
//  "merchantIdentifier": "FFF6C218C3579344C2843B2E94332D5BB59670F7A1B2F86E2ECC86DAEBC5290E",
//  "domainName": "consulting-huge-raymond-derby.trycloudflare.com",
//  "displayName": "MEEP SOLUCOES SA",
//  "signature": "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",
//  "operationalAnalyticsIdentifier": "MEEP SOLUCOES SA:FFF6C218C3579344C2843B2E94332D5BB59670F7A1B2F86E2ECC86DAEBC5290E",
//  "retries": 0,
//  "pspId": "FFF6C218C3579344C2843B2E94332D5BB59670F7A1B2F86E2ECC86DAEBC5290E"
//}